import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  // detect user language
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    debug: true,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      fr: {
        translation: {
          //here we place our translations...
          header: {
            dashboard: 'Dashboard',
            reclamation: 'Réclamations',
            utilisateur: 'Utilisateurs',
            telecharger_le_csv: 'Télécharger le CSV',
            mobile_csv: 'CSV',
            filtrer: 'Filtrer',
            du: 'du',
            au: 'au',
            jours: 'Jours',
          },
          professions: {
            nonPrecised: 'N/A',
            sansEmploi: 'Sans emploi',
            etudiant: 'Etudiant',
            employed: 'Employé',
            commercant_liberalProfession: 'Commerçant / Profession libérale',
            chefEntreprise: "Chef d'entreprise",
            other: 'Autre',
          },
          layout: {
            accountBlocked:
              'Votre compte a été bloqué veuillez contacter votre administrateur',
            disconnect: 'Se déconnecter',
          },
          toggleButton: {
            Fr: 'Fr',
            Ar: 'Ar',
          },
          genders: {
            homme: 'Homme',
            femme: 'Femme',
            nonPrecised: 'Non précisé',
          },
          activeContributor: {
            actif: 'Actifs',
            nonActif: 'Innactifs',
          },
          userPresentation: {
            user: 'Utilisateur:',
            role: 'Role:',
            admin: 'Administrateur',
            supervisor: 'Superviseur',
            intervenant: 'Intervenant',
            // mem
            // seniorIntervenor: "Superviseur",
            seniorIntervenor: 'Superviseur_SA',
            // mem
            intervenantSA: 'Intervenant_SA',
            detailProfile: 'Détails Profile',
            changePassword: 'Changez votre mot de passe',
            oldAndNewPassword:
              'Veuillez entrer votre ancien et nouveau mot de passe',
            confirmPasswordError:
              'La confirmation doit etre identique au nouveau mot de passe.',
            currentPassword: 'Mot de passe actuel',
            newPassword: 'Nouveau mot de passe',
            confirmPassword: 'Confirmez votre nouveau mot de passe',
            valider: 'valider',
            challengeSupervisor: 'Superviseur Challenge'
          },
          supervisorList: {
            liste_des_superviseur: 'Liste des supérviseurs',
            ajouter: 'Ajouter',
            bloquer: 'Bloquer',
            supprimer: 'Supprimer',
            email: 'Email',
          },
          usersList: {
            liste_des_utilisateurs: 'Liste des utilisateurs',
            filtrer: 'Filtrer',
            contact: 'Contact',
            numero_de_tel: 'Numéro de tel',
            genre: 'Genre',
            profession: 'Professions',
            tranches_d_age: "Tranche d'âge",
            wilaya: 'Wilaya',
            // edit here
            //commune: 'Commune',
            commune: 'APC',
            // here edit
            appliquer: 'Appliquer',
            reinitialiser: 'Réinitialiser',
          },
          intervenantList: {
            liste_des_intervenants: 'Liste des Intervenants',
            ajouter: 'Ajouter',
            //added by hamza start
            filtrer: 'Filtrer',
            //added by hamza end
            bloquer: 'Bloquer',
            supprimer: 'Supprimer',
            email: 'Email',
            entityType: "Type d'organisme",
            entityName: "Nom d'organisme",
            wilaya: 'Wilaya',
            // edit here
            // commune:'Commune',
            commune: 'APC',
            creationDate: 'Date de création',
            supprimer_intervenant: 'voulez-vous supprimer cet intervenant ?',
            le_compte: 'le compte ',
            sera_supprime_definitivement:
              " sera supprimé définitivement et n'aura plus accès à son compte. confirmez vous cette action ?",
            // mem
            phoneIntervenant: 'Num. Tel.',
            // mem
            contactIntervenant: 'Contact',
            // mem
            contactEmail: 'Email Contact',
            // mem
            contactPhoneNumber: 'Num. Tel. Contact',
            // mem
            importIntervenant: 'Importer',
            // thr
            importWilaya: 'Importer des wilayas',
            // thr
            importDaira: 'Importer des dairas',
            // mem
            importerLabel: 'Importer des intervenants',
            // mem
            tableauAction: 'Actions',
            // mem:
            debloquerIntervenant: 'Debloquer',
            // mem
            voirDetails: 'Voir Détails',
            // mem
            paginationIntervenant: 'Intervenants par page:',
            // mem
            telechargerModele: 'Télécharger modèle',
            // mem
            buttonTelechargerModeleWilaya: 'Télécharger modèle wilaya',
            // thr
            buttonTelechargerModeleDaira: 'Télécharger modèle daira',
            // mem
            modifierIntervenant: 'Modifier',
            // thr
            intervenorsSubmited:
              'Les nouveaux intervenants ont été bien insérés',
          },
          entityType: {
            epic: 'Epic',
            apc: 'APC',
            de: 'D.E',
            wilaya: 'Wilaya',
            daira: 'Daira',
          },
          forgetPassword: {
            passwordQuestion: 'Mot de passe oublié ?',
            enterEmail:
              'Veuillez entrer votre e-mail, afin de réinitialiser votre mot de passe',
            goBack: "Revenir a la page d'acceuil",
          },
          actionMenu: {
            image: 'Image',
            localisation: 'Localisation',
            annulerReclamation: 'Annuler Réclamation',
            reinitialiser_reclamation: 'réinitialiser la réclamation',
            assigner: 'Envoyer',
            reassigner: 'Réenvoyer',
            en_traitement: 'En cours de traitement',
            traite: 'Traitée',
            confirmed: 'Confirmée',
            returned: 'Retourner',
            relaunch: 'Relancer',
            cancelComplaint: 'Voulez vous annuler la réclamation ?',
            cancel: 'Annuler',
            relaunch_complaint: 'Voulez vous relancer la réclamation ?',
            resolved: 'Résoudre',
            intervenants: 'Choisir un intervenant',
            confirm_resolution:
              'Voulez-vous confirmer la résolution de la réclamation ?',
            commentary: 'Commentaires',
            return: 'Retourner',
            timeLimits: 'Délais',
            launch_treatement: 'Lancer le Traitement',
            treatedImage: 'Image traitée',
            // mem
            confirmedImage: 'Image Confirmation',
            resolve: 'Résoudre',
            returnedCommentary: 'Commentaire retourné : ',
            detail_retour: 'Détails Retour',
            operationDetails: 'Détails des opérations',
            close: 'Fermer',
            unresolve: 'Non traitée',
            confirm_unresolution:
              'Voulez-vous confirmer la non résolution de la réclamation ?',
          },
          listItems: {
            dashboard: 'Dashboard',
            reclamations: 'Réclamations',
            assignedComplaints: 'Réclamations',
            utilisateurs: 'Utilisateurs',
            intervenants: 'Intervenants',
            administration: 'Administration',
            profile: 'Profile',
            deconnecter: 'Déconnecter',
            guide: "Guide d'utilisation",
            addGuide: 'Ajouter Guide',
            uploadPDF: 'Ajouter nouveau guide PDF Intervenant',
            // mem
            // uploadPDFWilaya: "Ajouter nouveau guide PDF Intervenant Wilaya",
            uploadPDFWilaya: 'Ajouter nouveau guide PDF Intervenant_SA',
            pdfUploadTitle: "Gestion des guides d'utilisation",
            seePDF: 'Consultez le guide PDF Intervenant',
            // mem
            // seePDFWilaya: "Consultez le guide PDF Intervenant Wilaya",
            seePDFWilaya: 'Consultez le guide PDF Intervenant_SA',
            buttonUploadPdf: 'Envoyer',
            // mem
            supprimerPDF: 'Supprimer Guide PDF pour Intervenant',
            // mem
            buttonSupprimer: 'Supprimer',
            // mem
            // supprimerPDFWilaya: 'Supprimer Guide PDF pour Intervenant Wilaya',
            supprimerPDFWilaya: 'Supprimer Guide PDF pour Intervenant_SA',
            challengeParticipations: 'Participations au Challenge'
          },
          dashboardFilter: {
            tranches_d_age: "Tranches d'age",
            actif: 'Actif',
            genre: 'Genre',
            profession: 'Profession',
            wilaya: 'Wilaya',
            // edit here
            // communes: 'Communes',
            communes: 'APC',
            dateFilterText_first: 'Choisir parmi les derniers',
            dateFilterText_second: 'Choisir une date',
            date_debut: 'Date début',
            date_fin: 'Date fin',
            appliquer: 'Appliquer',
            reinitialiser: 'Réinitialiser',
            status: 'Status',
            type: 'Type',
            nature: 'Nature',
            dairas: 'Daira',
          },
          complaintsFilter: {
            complaintId: 'ID',
            contact: 'Contact',
            numero_de_tel: 'Numéro de tél',
            status: 'Statut',
            date_debut: 'Date début',
            date_fin: 'Date fin',
            heure_debut: 'Heure début',
            heure_fin: 'Heure fin',
            type: 'Type',
            nature: 'Nature',
            wilaya: 'Wilaya',
            // edit here
            // commune: 'Commune',
            commune: 'APC',
            filtrer: 'Filtrer',
            reinitialiser: 'Réinitialiser',
            appliquer: 'Appliquer',
          },
          complaintsTable: {
            liste_des_reclamations: 'Liste des réclamations',
            contact: 'Contact',
            nature: 'Nature',
            type_de_dechets: 'Type de déchets',
            date: 'Date',
            localisation: 'Localisation',
            lastOperationDate: 'Dernière opération',
            status: 'Statut',
            act: 'Act',
            il_nya_aucune_reclamation_disponible:
              "il n'a aucune réclamation disponible",
            generer_pdf: 'Génerer le PDF',
            veuillez_choisir_la_langue_pdf: 'Veuillez choisir la langue du PDF',
            fr: 'Français',
            ar: 'Arabe',
            veuillez_patienter_pendant_la_generation_pdf:
              'Veuillez patienter pendant la génération du PDF',
            lastOperationDate: 'Dernière Opération',
            nouvelle: 'Nouvelle',
            resolved: 'Classée',
            canceled: 'Annulée',
            assigned: 'Envoyée',
            on_treatment: 'En cours de traitement',
            returned: 'Retour',
            relaunched: 'Relancée',
            treated: 'Traitée',
            confirmed: 'Confirmée',
            // mem
            paginationComplaint: 'Réclamations par page:',
            unresolved: 'Non traitée',
          },
          contributorTab: {
            nombre_utilisateur: "Nombre d'utilisateurs",
            repartition_utilisateur_par_age:
              'Répartition des utilisateurs par âge',
            par_tranche_age:
              'Par tranches d’âges (15-25 / 26-35 / 36-45/46-55/56-65/>65/Non renseigné)',
            repartition_utilisateur_actif_inactif:
              "Répartition d'utilisateurs actif / inactif",
            repartition_utilisateur_par_actif_inactif:
              "Répartition d'utilisateurs par actif / inactif",
            repartition_utilisateur_par_genre:
              "Répartition d'utilisateurs par genre",
            repartition_utilisateur_par_genre_h_ou_f:
              'Répartition Utilisateurs par genre (Homme, Femme, Non renseigné',
            repartition_par_occupation: 'Répartition  par  occupation',
            par_statut_professionnel:
              'Par statut professionnel (Sans Emploi, Étudiant, Employé, Commerçant / prof libérales, Chef d’entreprise, Autre, Non renseigné)',
            classement_par_nombre_utilisateur:
              'Classement par nombre d’utilisateur',
            top_10_wilaya_par_nombre_utlisateur:
              'Top 10 wilayas par nombre d’utilisateur, down 10 wilayas par nombre d’utilisateurs',
            donut: 'Anneau',
            bars: 'Histogramme',
            line: 'Courbe',
          },
          complaintTab: {
            nombre_de_reclamation: 'Nombre de réclamations',
            moyenne_jour: 'Moyenne par jour',
            reclamation_resolue: 'Réclamations résolues',
            reclamation_onTreatment: 'Réclamations en cours de traitement',
            repartition_par_type: 'Répartition par type',
            declaration_par:
              'Déclaration par (parts de déchets inertes, végétaux, ménagers, encombrants, autres)',
            repartition_par_nature: 'Répartition par Nature',
            declaration_par_type: 'Déclarations par type de déchet',
            repartition_par_statut: 'Répartition par status',
            repartition_par_statut_nouvelle:
              'Répartition par status (Nouvelle, Envoyée, Annulée)',
            classement_par_reclamation: 'Classement par nombre de réclamations',
            classement_des_wilaya:
              'Classement des wilayas par type de déchets déclaré (pour chaque type de déchet)',
            classement_par_reclamation_dairas: 'Classement par nombre de réclamations wilaya de ',
            classement_des_dairas:
              'Classement des dairas par type de déchets déclaré (pour chaque type de déchet) wilaya de ',
            donut: 'Anneau',
            bars: 'Histogramme',
            line: 'Courbe',
            nouvelle: 'Nouvelle',
            resolue: 'Classée',
            annule: 'Annulée',
            assignee: 'Envoyée',
            en_traitement: 'En cours \n\rde traitement',
            returned: 'Retour',
            relaunched: 'Relancée',
            treated: 'Traitée',
            confirmed: 'Confirmée',
            unresolved: 'Non traitée',
          },
          trashTypes: {
            dechet_inertes: 'Déchets inertes',
            // edit here:
            // dechet_vert: "Déchets verts",
            dechet_vert: 'Déchets verts',
            dechet_menagers_assimile: 'Déchets ménagers et assimilés',
            dechet_encombrant: 'Déchets encombrants',
            dechet_mixte: 'Déchets mixtes',
          },
          natures: {
            depotoire_sauvage: 'Point noir',
            collect_default: 'Défauts de collecte',
          },
          wilayaList: {
            du: 'du',
            au: 'au',
            wilaya: 'Wilaya',
            nombre: 'Nombre',
            jours: 'Jours',
          },
          contributorTable: {
            contact: 'Contact',
            genre: 'Genre',
            date_de_naissance: 'Date de naissance',
            residence: 'Résidence',
            // occupation: 'Occupation'
            occupation: 'Statu',
          },
          login: {
            connexion: 'Connexion',
            mot_de_passe_oublie: 'Mot de passe oublié ?',
            se_connecter: 'Se connecter',
            email: 'Adresse Email',
            password: 'Mot de passe',
          },
          assignementForm: {
            email: 'Email',
            entityType: "Type d'organisme",
            entityName: "Nom d'organisme",
            wilaya: 'Wilayas',
            // edit here
            // commune: "Communes",
            commune: 'APC',
            assigner: 'Envoyer',
            comment: 'Commentaire',
          },
          returnForm: {
            commentary: 'Commentaires',
            return: 'Retourner',
            timeLimits: 'Délais',
          },
          treatedForm: {
            uploadImage: 'Téléchargez vos images',
            treated: 'Confirmez le traitement',
            commentary: 'Commentaire',
            addImage: 'Ajouter une autre image',
            not_treated: 'Confirmez le non traitement',
          },
          statuses: {
            assigner: 'Envoyée',
            on_treatment: 'En cours de traitement',
            treated: 'Traitée',
            returned: 'Retournée',
            unresolved: 'Non traitée',
          },
          timeLimit: {
            oneDay: '1 Jour',
            twoDays: '2 Jours',
            threeDays: '3 Jours',
            fourDays: '4 Jours',
            fiveDays: '5 Jours',
          },
          relaunchedCommentaries: {
            problemePersistant: 'Problème persiste',
            problemeAggrave: 'Problème aggravé',
            otherReason: 'Autre raison',
          },
          returnCommentaries: {
            commentaryOne: 'Manque de moyens-matériels',
            commentaryTwo: "Manque d'effectifs",
            commentaryThree: 'Matériels en panne',
            commentaryFour: 'Propriété privée',
            commentaryFive: 'Autre',
            otherReason: 'Autre raison',
          },
          showAlert: {
            une_erreur_est_survenue: 'Une erreur est survenue !',
            cet_assignement_est_deja_fait: 'Cet assignement est déja fait',
            vous_netes_pas_autorise_a_effectuer_cette_action:
              "Vous n'êtes pas autorisé à éffectuer cette action",
            la_reclamation_a_bien_ete_assignee:
              'La réclamation a bien été envoyée',
            la_reclamation_a_bien_ete_retournee:
              'La réclamation a bien été retournée',
            cette_reclamation_est_deja_retournee:
              'Cette réclamation est déjà retournée',
            le_statut_de_traitement_a_bien_ete_envoyee:
              'Le statut de traitement a bien été envoyé',
            la_reclamation_a_bien_ete_annulee:
              'La réclamation a bien été annulée',
            le_statut_de_traitement_a_bien_ete_resolue:
              'Le statut de traitement a bien été résolu',
            la_reclamation_a_bien_ete_relancee:
              'La réclamation a bien été relancée',
            cet_assignement_a_deja_commence_a_etre_traite:
              'Cet assignement a déjà commencé a être traité',
            cet_assignement_est_deja_traite: 'Cet assignement est déjà traité',
            envoieGuidePDF: 'Guide Envoyé',
            // mem
            imageTraitementNonEnvoye:
              "Veuillez selectionner l'image de traitment",
            fileSizeTooLarge:
              'La taille du fichier est trop grande et dépasse 20 MB',
            imageSizeTooLarge:
              "La taille de l'image est trop grande et dépasse 5 MB",
            fileNotPdf: "Le fichier n'est de type PDF !",
            fileNotImage: "Le fichier n'est de type image !",
            fileNotFound: "Le fichier n'est pas trouvé !",
            cet_email_existe_deja: 'Cet email existe déjà',
            mot_de_passe_incorrect: 'Mot de passe incorrect !',
            identifiants_incorrects: 'Identifiants incorrects !',
            liste_nest_pas_trouve: "Liste n'est pas trouvée !",
            utilisateur_nest_superviseur: "Vous n'êtes pas un superviseur !",
            operation_non_autorise:
              'Vous ne pouvez pas effectuer cette opération !',
            utilisateur_nest_intervenant: "Vous n'êtes pas un intervenant !",
            utilisateur_nest_superviseur_nest_intervenant:
              "Vous n'êtes ni superviseur ni intervenant !",
            nomWilaya_ou_email_non_trouve:
              "Nom wilaya ou email n'est pas trouvé !",
            nomWilaya_ou_nomDaira_email_non_trouve:
              "Nom wilaya ou nom daira ou email n'est pas trouvé !",
            utilisateur_non_existant: "Cet utilisateur n'existe pas !",
            le_statut_de_traitement_a_ete_enregistrer_non_traite:
              'Le statut de la réclamation a été enregistré en tant que non traitée',
          },
          operationDetails: {
            actionBy: 'Action Par',
            actionMade: 'Action faite',
            info: 'Infos',
            timeLimit: 'Délais',
            status: 'Status',
            creationDate: 'Date de création',
            phoneUser: 'Utilisateur (Citoyen)',
            assignedTo: 'Envoyée à',
          },
          time: {
            at: 'à',
          },
          deleteUserData: {
            title: 'Supprimer les données personnelles',
            submitRequest: 'Soumettre une demande',
            phoneNumber: 'Numéro de tél',
            submitConfirmation: 'Demande de suppression de données personnelles soumise avec succès!',
            requestPending: 'Votre demande est en cours de traitement.',
            requestApproved: 'Votre demande est approuvée.',
          },
          challengeParticipationsTable: {
            liste_des_participations: 'Liste des participations',
            paginationChallengeParticipation: 'Participations par page:',
            il_nya_aucune_participation_disponible: "Il n'y a aucune participation disponible!",
            localisation_avant: 'Localisation Avant',
            localisation_apres: 'Localisation Après',
            nombre_de_participation: 'Nombre de participations',
            moyenne_jour: 'Moyenne par jour',
            top_wilaya: 'Top wilaya',
            top_daira: 'Top daira',
            classement_par_participation: 'Classement par nombre de participations',
            classement_par_participation_description: 'Classement des wilayas par nombre de participations',
            classement_par_participation_dairas: 'Classement par nombre de participations wilaya de ',
            classement_par_participation_dairas_description: 'Classement des dairas par nombre de participations wilaya de ',
            accepted: 'Acceptée',
            accept_participation: 'Accepter Participation',
            accept_participation_confirm: 'Voulez vous accepter cette participation?',
            accept: 'Accepter',
            cancel_participation: 'Annuler Participation',
            cancel_participation_confirm: 'Voulez vous annuler cette participation?',
            participation_has_been_accepted: 'La participation a été bien acceptée.',
            participation_has_been_canceled: 'La participation a été bien annulée.'
          }
        },
      },
      ar: {
        translation: {
          header: {
            dashboard: 'لوحة القيادة',
            reclamation: 'الشكاوى',
            utilisateur: 'المستخدمون',
            telecharger_le_csv: 'تحميل الملف',
            mobile_csv: 'الملف',
            filtrer: 'تصفية',
            du: 'من',
            au: 'إلى',
            jours: 'يوم',
          },
          professions: {
            nonPrecised: 'غير معلن',
            sansEmploi: 'عاطل عن العمل',
            etudiant: 'طالب',
            employed: 'موظف',
            commercant_liberalProfession: 'تاجر/ أعمال حرة',
            chefEntreprise: 'مدير مؤسسة',
            other: 'أخرى',
          },
          layout: {
            accountBlocked: 'تم حظر حسابك ، يرجى الاتصال بالمسؤول',
            disconnect: 'تسجيل الخروج',
          },
          toggleButton: {
            Fr: 'فرنسية',
            Ar: 'عربية',
          },
          genders: {
            homme: 'ذكر',
            femme: 'أنثى',
            nonPrecised: 'غير محدد',
          },
          activeContributor: {
            actif: 'النشطين',
            nonActif: 'غير النشطين',
          },
          userPresentation: {
            user: 'المستعمل:',
            role: 'دور:',
            admin: 'مدير',
            supervisor: 'مشرف',
            intervenant: 'متدخل',
            // mem
            // seniorIntervenor: "مشرف",
            seniorIntervenor: 'مشرف_بت',
            // mem
            intervenantSA: 'متدخل_بت',
            detailProfile: 'تفاصيل الملف الشخصي',
            changePassword: 'غير كلمه السر الخاصة بك',
            oldAndNewPassword: 'الرجاء إدخال كلمه السر القديمة والجديدة',
            confirmPasswordError:
              'يجب أن يكون التأكيد مطابقًا لكلمة السر الجديدة',
            currentPassword: 'كلمة السر الحالية',
            newPassword: 'كلمة السر جديدة',
            confirmPassword: 'قم بتأكيد كلمة السر الجديدة الخاصة بك',
            valider: 'تأكيد',
            challengeSupervisor: 'مشرف تحدي'
          },
          supervisorList: {
            liste_des_superviseur: 'قائمة المشرفين',
            ajouter: 'إضافة',
            bloquer: 'منع',
            supprimer: 'حذف',
            email: 'البريد الالكتروني',
          },
          usersList: {
            liste_des_utilisateurs: 'قائمة المستخدمين',
            filtrer: 'تصفية',
            // contact: 'شخص',
            contact: 'المرسل',
            numero_de_tel: 'رقم الهاتف',
            genre: 'النوع',
            profession: 'مهنة',
            tranches_d_age: 'الفئات العمرية',
            wilaya: 'ولاية',
            commune: 'بلدية',
            appliquer: 'تطبيق',
            reinitialiser: 'تجديد',
          },
          intervenantList: {
            liste_des_intervenants: 'قائمة المتدخلين',
            ajouter: 'إضافة',
            //added by hamza start
            filter: 'بحث',
            //added by hamza end
            bloquer: 'منع',
            supprimer: 'حذف',
            email: 'البريد الالكتروني',
            // edit here
            //entityType: 'نوع الكيان',
            entityType: 'نوع الهيئة',
            //entityName:'اسم الكيان',
            entityName: 'اسم الهيئة',
            wilaya: 'ولاية',
            commune: 'البلدية',
            creationDate: 'تاريخ الإنشاء',
            supprimer_intervenant: 'هل تريد إزالة هذه السماعة ؟',
            le_compte: ' سيتم حذف حساب ',
            sera_supprime_definitivement:
              ' نهائيًا ولن يعود بإمكانه الوصول إلى حسابه. هل تؤكد هذا العمل ؟ ',
            // mem
            phoneIntervenant: 'رقم الهاتف',
            // mem
            contactIntervenant: 'هوية الإطار',
            // mem
            contactEmail: 'البريد الالكتروني للإطار',
            // mem
            contactPhoneNumber: 'رقم الهاتف للإطار',
            // mem
            importIntervenant: 'رفع',
            // thr
            importWilaya: 'رفع الولايات',
            // thr
            importDaira: 'رفع الدوائر',
            // mem
            importerLabel: 'رفع المتدخلين',
            // mem
            tableauAction: 'العمليات',
            // mem:
            debloquerIntervenant: 'إلغاء المنع',
            // mem
            voirDetails: 'التفاصيل',
            // mem
            paginationIntervenant: 'عدد المتدخلين في الصفحة:',
            // mem
            telechargerModele: 'تحميل النموذج',
            // mem
            buttonTelechargerModeleWilaya: 'تحميل نموذج الولاية',
            // thr
            buttonTelechargerModeleDaira: 'تحميل نموذج الدائرة',
            // mem
            modifierIntervenant: 'تحديث',
            // thr
            intervenorsSubmited: 'تمت إضافة المتدخلين الجدد بنجاح',
          },
          entityType: {
            epic: 'مؤسسة عامة ذات طبيعة صناعية و تجارية',
            apc: 'بلدية',
            de: 'مديرية البيئة',
            wilaya: 'الولاية',
            daira: 'دائرة',
          },
          forgetPassword: {
            passwordQuestion: 'نسيت كلمةالسر؟',
            enterEmail:
              'الرجاء إدخال بريدك الإلكتروني لإعادة تعيين كلمة السر الخاصة بك',
            goBack: 'العودة إلى الصفحة الرئيسية',
          },
          actionMenu: {
            image: 'صورة',
            localisation: 'موقع',
            annulerReclamation: 'إلغاء الشكوى',
            // edit here
            // reinitialiser_reclamation: 'إعادة تعيين المطالبة',
            reinitialiser_reclamation: 'إعادة ارسال الشكوى',
            // assigner: 'تعيين',
            assigner: 'ارسال',
            // reassigner: 'إعادة التعيين',
            reassigner: 'إعادة الارسال',
            // edit here
            // en_traitement: 'في طور المعالجة',
            en_traitement: 'قيد المعالجة',
            traite: 'معالجة',
            confirmed: 'منجزة',
            // returned: 'إرجاع',
            returned: 'رجوع',
            relaunch: 'إعادة إطلاق',
            cancelComplaint: 'هل تريد إلغاء المطالبة؟',
            cancel: 'إلغاء',
            relaunch_complaint: 'هل تريد إعادة إطلاق المطالبة؟',
            intervenants: 'اختر المتدخل',
            confirm_resolution: 'هل تريد تأكيد حل الشكوى؟',
            commentary: 'تعليق',
            return: 'إرجاع',
            timeLimits: 'تحديد الوقت',
            launch_treatement: 'بدء المعالجة',
            treatedImage: 'صورة المعالجة',
            // mem
            confirmedImage: 'صورة التاكيد',
            resolved: 'تأكيد الحل',
            returnedCommentary: 'التعليق الذي تم إرجاعه:',
            close: 'أغلق',
            detail_retour: 'تفاصيل العودة',
            // operationDetails: 'تفاصيل الصفقه',
            operationDetails: 'تفاصيل الشكوى',
            close: 'غلق',
            unresolve: 'غير معالجة',
            confirm_unresolution: 'هل تريد تأكيد عدم معالجة الشكوى؟',
          },
          listItems: {
            dashboard: 'لوحة القيادة',
            // reclamations: 'شكوى',
            reclamations: 'الشكاوى',
            // assignedComplaints: 'شكوى',
            assignedComplaints: 'الشكاوى',
            utilisateurs: 'المستخدمون',
            intervenants: 'المتدخلون',
            administration: 'إدارة',
            profile: 'الملف الشخصي',
            deconnecter: 'تسجيل الخروج',
            guide: 'دليل الإستخدام',
            addGuide: 'إضافة دليل الإستخدام',
            uploadPDF: 'إضافة دليل الإستخدام للمتدخل',
            // mem
            uploadPDFWilaya: 'إضافة دليل الإستخدام للمتدخل_بت',
            pdfUploadTitle: 'إدارة دلائل الإستخدام',
            seePDF: 'الإطلاع على دليل الإستخدام للمتدخل',
            // mem
            seePDFWilaya: 'الإطلاع على دليل الإستخدام للمتدخل_بت',
            buttonUploadPdf: 'اضافة',
            // mem
            supprimerPDF: 'حذف دليل الإستخدام للمتدخل',
            // mem
            buttonSupprimer: 'حذف',
            // mem
            supprimerPDFWilaya: 'حذف دليل الإستخدام للمتدخل_بت',
            challengeParticipations: 'المشاركات في التحدي'
          },
          dashboardFilter: {
            tranches_d_age: 'الفئات العمرية',
            actif: 'نشط/ غير نشط',
            genre: 'الجنس',
            profession: 'طبيعة النشاط',
            wilaya: 'ولاية',
            communes: 'بلدية',
            dateFilterText_first: 'اختر من الأخير:',
            dateFilterText_second: 'تحديد موعد',
            date_debut: 'تاريخ البداية',
            date_fin: 'تاريخ الانتهاء',
            appliquer: 'تطبيق',
            reinitialiser: 'إعادة الضبط',
            status: 'الحالة',
            type: 'نوع',
            nature: 'طبيعة',
            dairas: 'دائرة',
          },
          complaintsFilter: {
            // contact: 'شخص',
            contact: 'المرسل',
            numero_de_tel: 'رقم الهاتف',
            status: 'الحالة',
            date_debut: 'تاريخ البداية',
            date_fin: 'تاريخ الانتهاء',
            heure_debut: 'وقت البداية',
            heure_fin: 'وقت النهاية',
            type: 'نوع',
            nature: 'طبيعة',
            wilaya: 'ولاية',
            commune: 'بلدية',
            appliquer: 'تطبيق',
            reinitialiser: 'تجديد',
            filtrer: 'تصفية',
          },
          complaintsTable: {
            liste_des_reclamations: 'قائمة الشكاوى',
            // contact: 'شخص',
            contact: 'المرسل',
            nature: 'طبيعة',
            type_de_dechets: 'نوع النفايات',
            date: 'توقيت',
            localisation: 'موقع',
            status: 'الحالة',
            act: 'فعل',
            il_nya_aucune_reclamation_disponible: 'ليس لديه ادعاءات متاحة',
            generer_pdf: 'تحميل الملف',
            veuillez_choisir_la_langue_pdf: 'الرجاء اختيار اللغة',
            fr: 'فرنسية',
            ar: 'عربية',
            veuillez_patienter_pendant_la_generation_pdf:
              'يرجى الانتظار حتى يتم إنشاء الملف',
            lastOperationDate: 'العملية الأخيرة',
            nouvelle: 'جديدة',
            resolved: 'مصنفة',
            canceled: 'ملغاة',
            assigned: 'مرسلة',
            on_treatment: 'قيد المعالجة',
            returned: 'رجوع',
            relaunched: 'معادة',
            treated: 'معالجة',
            confirmed: 'مؤكدة',
            // mem
            paginationComplaint: 'عدد الشكاوى في الصفحة:',
            unresolved: 'غير معالجة',
          },
          contributorTab: {
            nombre_utilisateur: 'عدد المستخدمين',
            repartition_utilisateur_par_age:
              'تقسيم المستخدمين حسب الفئات العمرية',
            par_tranche_age:
              'حسب الفئات العمرية (15-25 / 26-35 / 36-45 / 46-55 / 56-65 /> 65 / غير معلن)',
            repartition_utilisateur_actif_inactif:
              'تفصيل المستخدمين النشطين / غير النشطين',
            repartition_utilisateur_par_actif_inactif:
              'تصنيف المستخدمين حسب النشطين / غير النشطين',
            repartition_utilisateur_par_genre: 'تقسيم المستخدمين حسب الجنس',
            repartition_utilisateur_par_genre_h_ou_f:
              'توزيع المستخدمين حسب الجنس (ذكر ، أنثى ، غير معبأ)',
            repartition_par_occupation: 'التقسيم حسب النشاط',
            par_statut_professionnel:
              'حسب الحالة المهنية (عاطل عن العمل ، طالب ، موظف ، تاجر / مدرس ليبرالي ، مدير أعمال ، غير ذلك ، غير مُعلم)',
            classement_par_nombre_utilisateur:
              'تصنيف الولايات حسب عدد المستخدمين الولاية / العدد',
            top_10_wilaya_par_nombre_utlisateur:
              'أهم 10 ولايات من حيث عدد المستخدمين ، بانخفاض 10 ولايات من حيث عدد المستخدمين',
            donut: 'رسم بياني دائري',
            bars: 'رسم بياني عمودي',
            line: 'منحنى بياني',
          },
          complaintTab: {
            nombre_de_reclamation: 'عدد الشكاوى',
            moyenne_jour: 'متوسط الشكاوى في اليوم',
            reclamation_resolue: 'الشكاوى المعالجة',
            // edit here
            // reclamation_onTreatment: "الشكاوى طور المعالجة",
            reclamation_onTreatment: 'الشكاوى قيد المعالجة',
            repartition_par_type: 'التقسيم حسب النوع',
            declaration_par:
              'إقرار (حصص نفايات خاملة ، نباتية ، منزلية ، كبيرة الحجم ، نفايات أخرى)',
            repartition_par_nature: 'تقسيم حسب طبيعة الشكاوى ',
            declaration_par_type: 'تقسيم حسب نوع النفايات ',
            repartition_par_statut: 'تقسيم حسب حالة الشكوى ',
            repartition_par_statut_nouvelle:
              'التقسيم حسب الحالة (جديد ، مرسل ، ملغى)',
            classement_par_reclamation: 'تصنيف الولايات حسب عدد الشكاوى',
            classement_des_wilaya:
              'تصنيف الولايات حسب نوع النفايات المعلن عنها (لكل نوع من أنواع النفايات)',
            classement_par_reclamation_dairas: 'تصنيف الدوائر حسب عدد الشكاوى ولاية ',
            classement_des_dairas:
              'تصنيف الدوائر حسب نوع النفايات المعلن عنها (لكل نوع من أنواع النفايات) ولاية ',
            donut: 'رسم بياني دائري',
            bars: 'رسم بياني عمودي',
            line: 'منحنى بياني',
            nouvelle: 'جديدة',
            resolue: 'مصنفة',
            annule: 'ملغاة',
            assignee: 'مرسلة',
            en_traitement: 'قيد المعالجة',
            returned: 'رجوع',
            relaunched: 'معادة',
            treated: 'معالجة',
            confirmed: 'مؤكدة',
            unresolved: 'غير معالجة',
          },
          trashTypes: {
            dechet_inertes: 'نفايات هامدة',
            dechet_vert: 'نفايات خضراء',
            dechet_menagers_assimile: 'نفايات منزلية و ما شابهها',
            dechet_encombrant: 'نفايات ضخمة',
            dechet_mixte: 'نفايات مختلطة',
          },
          natures: {
            // depotoire_sauvage: "مفرغة عشوائية",
            depotoire_sauvage: 'نقطة سوداء',
            collect_default: 'تذبذب في عملية جمع النفايات',
          },
          actives: {
            actif: 'نشيط',
            non_actif: 'غير نشيط',
          },
          wilayaList: {
            du: 'من',
            au: 'إلى',
            wilaya: 'ولاية',
            nombre: ' عدد المستخدمين',
            jours: 'يوم',
          },
          contributorTable: {
            // contact: 'شخص',
            contact: 'المرسل',
            genre: 'النوع',
            date_de_naissance: 'تاريخ الولادة',
            residence: 'إقامة',
            occupation: 'نشاط',
          },
          login: {
            connexion: 'تسجيل الدخول',
            mot_de_passe_oublie: 'هل نسيت كلمة السر؟',
            se_connecter: 'تسجيل الدخول',
            email: 'البريد الإلكتروني',
            password: 'كلمة السر',
          },
          assignementForm: {
            email: 'البريد الإلكتروني',
            //entityType: "نوع الكيان",
            entityType: 'نوع الهيئة',
            wilaya: 'ولاية',
            commune: 'البلدية',
            // edit here
            // assigner: "تعيين",
            assigner: 'ارسال',
            comment: 'تعليق',
          },
          returnForm: {
            commentary: 'تعليق',
            return: 'إرجاع',
          },
          treatedForm: {
            uploadImage: 'تحميل الصور',
            treated: 'تأكيد المعالجة',
            commentary: 'تعليق',
            addImage: 'إضافة صورة أخرى',
            not_treated: 'تأكيد عدم المعالجة',
          },
          statuses: {
            // edit here
            // assigner: 'تعيين',
            assigner: 'ارسال',
            on_treatment: 'قيد المعالجة',
            treated: 'معالجة',
            returned: 'عاد',
            unresolved: 'غير معالجة',
          },
          timeLimit: {
            // oneDay: ' يوم 1',
            oneDay: 'يوم واحد',
            twoDays: 'يومان',
            threeDays: '3 أيام',
            fourDays: '4 أيام',
            fiveDays: '5 أيام',
          },
          relaunchedCommentaries: {
            problemePersistant: 'لا تزال هناك مشكلة',
            problemeAggrave: 'تفاقم المشكلة',
            otherReason: 'سبب آخر',
          },
          returnCommentaries: {
            commentaryOne: 'نقص في الموارد المادية',
            commentaryTwo: 'نقص في الموارد البشرية',
            commentaryThree: 'معدات معطلة',
            commentaryFour: 'ملكية خاصة',
            commentaryFive: 'آخر',
            otherReason: 'سبب آخر',
          },
          showAlert: {
            une_erreur_est_survenue: 'حدث خطأ !',
            cet_assignement_est_deja_fait: 'تم بالفعل هذا الواجب',
            vous_netes_pas_autorise_a_effectuer_cette_action:
              'أنت غير مخول للقيام بهذا الإجراء',
            // edit here
            // la_reclamation_a_bien_ete_assignee: "تم تعيين الشكوى",
            la_reclamation_a_bien_ete_assignee: 'تم ارسال الشكوى',
            la_reclamation_a_bien_ete_retournee: 'تم إرجاع الشكوى',
            cette_reclamation_est_deja_retournee:
              'تم إرجاع هذه المطالبة بالفعل',
            le_statut_de_traitement_a_bien_ete_envoyee:
              'تم إرسال حالة المعالجة بنجاح',
            la_reclamation_a_bien_ete_annulee: 'تم إلغاء الشكوى',
            la_reclamation_a_bien_ete_relancee: 'تم إعادة تقديم الشكوى',
            le_statut_de_traitement_a_bien_ete_resolue:
              'تم حل حالة المعالجة بنجاح',
            cet_assignement_a_deja_commence_a_etre_traite:
              'بدأت بالفعل معالجة هذا الواجب',
            cet_assignement_est_deja_traite: 'تمت معالجة هذا الواجب بالفعل',
            envoieGuidePDF: 'تم الارسال',
            // mem
            imageTraitementNonEnvoye: 'الرجاء ارسال صورة تاكيد المعالجة',
            fileSizeTooLarge: 'حجم الملف كبير جدًا ويتجاوز 20 ميغا بايت',
            imageSizeTooLarge: 'حجم الصورة كبيرة جدًا وتتجاوز 5 ميغا بايت',
            fileNotPdf: 'الملف ليس من نوع PDF !',
            fileNotImage: 'الملف ليس صورة !',
            fileNotFound: 'الملف غير موجود !',
            cet_email_existe_deja: 'هذا البريد الإلكتروني موجود من قبل',
            mot_de_passe_incorrect: 'كلمة السر خاطئة !',
            identifiants_incorrects: 'هوية المستخدم خاطئة !',
            liste_nest_pas_trouve: 'القائمة غير موجودة !',
            utilisateur_nest_superviseur: 'لستم مشرفا !',
            operation_non_autorise: 'لا يمكنكم إجراء هذه العملية !',
            utilisateur_nest_intervenant: 'لستم متدخلا !',
            utilisateur_nest_superviseur_nest_intervenant:
              'لستم مشرفا و لا متدخلا !',
            nomWilaya_ou_email_non_trouve:
              'إسم الولاية أو البريد الإلكتروني غير موجود !',
            nomWilaya_ou_nomDaira_email_non_trouve:
              'إسم الولاية أو إسم الدائرة أو البريد الإلكتروني غير موجود !',
            utilisateur_non_existant: 'هذا المستخدم غير موجود !',
            le_statut_de_traitement_a_ete_enregistrer_non_traite:
              'تم تسجيل الشكوى على أنها لم تتم معالجتها',
          },
          operationDetails: {
            actionBy: 'شارك بواسطة',
            actionMade: 'تم العمل',
            info: 'معلومات',
            timeLimit: 'المهلة الزمنية',
            status: 'حالة',
            creationDate: 'تاريخ ورود الشكوى',
            phoneUser: 'المستخدم (المواطن)',
            assignedTo: 'مخصص ل',
          },
          time: {
            // at: "الساعة"
          },
          deleteUserData: {
            title: 'حذف البيانات الشخصية',
            submitRequest: 'إرسال طلب',
            phoneNumber: 'رقم الهاتف',
            submitConfirmation: 'تم إرسال طلب حذف البيانات الشخصية بنجاح!',
            requestPending: 'طلبك قيد المعالجة.',
            requestApproved: 'تمت الموافقة على طلبك.',
          },
          challengeParticipationsTable: {
            liste_des_participations: 'قائمة المشاركات',
            paginationChallengeParticipation: 'عدد المشاركات في الصفحة:',
            il_nya_aucune_participation_disponible: "لا توجد مشاركات متاحة!",
            localisation_avant: 'الموقع قبل',
            localisation_apres: 'الموقع بعد',
            nombre_de_participation: 'عدد المشاركات',
            moyenne_jour: 'متوسط المشاركات في اليوم',
            top_wilaya: 'أعلى ولاية',
            top_daira: 'أعلى دائرة',
            classement_par_participation: 'تصنيف الولايات حسب عدد المشاركات',
            classement_par_participation_description: 'تصنيف الولايات حسب عدد المشاركات',
            classement_par_participation_dairas: 'تصنيف الدوائر حسب عدد المشاركات ولاية ',
            classement_par_participation_dairas_description: 'تصنيف الدوائر حسب عدد المشاركات ولاية ',
            accepted: 'مقبولة',
            accept_participation: 'قبول المشاركة',
            accept_participation_confirm: 'هل تريد قبول هذه المشاركة؟',
            accept: 'قبول',
            cancel_participation: 'إلغاء المشاركة',
            cancel_participation_confirm: 'هل تريد إلغاء هذه المشاركة؟',
            participation_has_been_accepted: 'تم تسجيل المشاركة مقبولة.',
            participation_has_been_canceled: 'تم إلغاء المشاركة.'
          }
        },
      },
    },
  })

export default i18n
